import { render, staticRenderFns } from "./OwnerScreen.vue?vue&type=template&id=0260126a&scoped=true&"
import script from "./OwnerScreen.vue?vue&type=script&lang=ts&"
export * from "./OwnerScreen.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerScreen.vue?vue&type=style&index=0&id=0260126a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0260126a",
  null
  
)

export default component.exports